import { Period } from '../enum/period';
import { Factory } from '../interface/factory';

export enum BillingScheduleType {
  FixedDate = 'FixedDate',
  PerProductPaymentSchedule = 'PerProductPaymentSchedule',
}

export class BillingSchedule {
  type: BillingScheduleType;
  constructor(json: any) {
    this.type = json.type;
  }

  static getFactory(): Factory<BillingSchedule> {
    return new (class implements Factory<BillingSchedule> {
      make(json: any): BillingSchedule {
        switch (json.type) {
          case BillingScheduleType.FixedDate:
            return new FixedDateBillingSchedule(json);
          case BillingScheduleType.PerProductPaymentSchedule:
            return new PerProductPaymentScheduleBillingSchedule(json);
          default:
            throw new Error('Unrecognized BillingSchedule type (' + json.type + ').');
        }
      }
      getTableName(): string {
        return 'BillingSchedules are never stored in IndexedDB.';
      }
    })();
  }
}

export class FixedDateBillingSchedule extends BillingSchedule {
  period: Period;
  referenceDate: Date;
  constructor(json: any) {
    super(json);
    this.period = json.period as Period;
    this.referenceDate = new Date(json.referenceDate);
  }
}

export class PerProductPaymentScheduleBillingSchedule extends BillingSchedule {
  constructor(json: any) {
    super(json);
  }
}
